<template>
  <div>
    <h6>Understanding the icons in the graph</h6>
    <p class="mt-5">
      To make it easy to identify life’s major milestones, we’ve created a set of icons representing
      your super, net wealth, and mortgages.
    </p>
    <div class="border border-blue-3 rounded-lg bg-white paragraph-1 my-10">
      <div class="flex gap-10 px-5 py-2.5">
        <div class="h-5 w-5 bg-blue-3 self-center border border-secondary rounded-full" />
        Super
      </div>
      <div class="flex gap-10 px-5 py-2.5 border-t border-blue-5">
        <div class="h-5 w-5 bg-green-4 self-center border border-secondary rounded-full" />
        Net wealth
      </div>
      <div class="flex gap-10 px-5 py-2.5 border-t border-blue-5">
        <div class="h-5 w-5 bg-gold-2 self-center border border-secondary rounded-full" />
        Mortgage
      </div>
    </div>
  </div>
</template>

<script setup lang="ts"></script>

<style scoped></style>
